<mat-card>
  <mat-card-header class="justify-content-between align-items-center mb-3">
    <mat-card-title class="fs-5 mb-0"> Latest users </mat-card-title>
    <button
      mat-button
      color="primary"
      [routerLink]="['/dashboard', 'users']"

    >
      See more
    </button>
  </mat-card-header>
  <div class="rounded-3 bg-light">
    <sm-data-table
      [columnHeaders]="tableDisplayColumns"
      [dataSource]="usersList"
      [showImageColumn]="true"
      [showMenuButton]="true"
      class="latest-user-list"
      [menuDropdownTemplate]="menuTemp"
      [imageTemplate]="image"
     
      [itemsPerPage]="5"
    >
    </sm-data-table>
  </div>
</mat-card>

<ng-template #menuTemp let-value>
  <button mat-menu-item (click)="viewProfile(value)">
    <mat-icon class="material-icons-outlined">account_circle</mat-icon>
    <span>See profile</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">email</mat-icon>
    <span>Send message</span>
  </button>
  <button mat-menu-item *ngIf="value.userType == 'owner' " (click)="viewBusiness(value)"> 
    <mat-icon class="material-icons-outlined">business_center</mat-icon>
    <span>View business</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">no_accounts</mat-icon>
    <span>Block</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">verified_user</mat-icon>
    <span>Unblock</span>
  </button>
</ng-template>

<ng-template #image let-objValue>
  <img
    [src]="
      objValue['imageUrl'] !== null && objValue['imageUrl'] !== 'null'
        ? objValue['imageUrl']
        : './assets/images/user-avatar.svg'
    "
    class="img-fluid rounded-circle"
  />
</ng-template>
